import { render, staticRenderFns } from "./updateCoordinate.vue?vue&type=template&id=92fe9f1a&"
import script from "./updateCoordinate.vue?vue&type=script&lang=js&"
export * from "./updateCoordinate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports